//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
SPLM.CAM.CamInspectionOperationCsysreferencetypes = Object.freeze({
    "RelativetoPCS" : "RelativetoPCS", "Absolute" : "Absolute"});

SPLM.CAM.CamInspectionOperationInneroutertypes = Object.freeze({
    "Inner" : "Inner", "Outer" : "Outer"});

SPLM.CAM.CamInspectionOperationExtenttypes = Object.freeze({
    "Bounded" : "Bounded", "Unbounded" : "Unbounded"});

SPLM.CAM.CamInspectionOperationFeaturetypes = Object.freeze({
    "None" : "None", "Arc" : "Arc", "Circle" : "Circle", "Point" : "Point", "Sphere" : "Sphere", "Surface" : "Surface", "Pattern" : "Pattern", "Curve" : "Curve", "Cylinder" : "Cylinder", "Cone" : "Cone", "Plane" : "Plane", "Line" : "Line", "Cparln" : "Cparln", "SlotTab" : "SlotTab", "SurfaceOfRevolution" : "SurfaceOfRevolution", "Torus" : "Torus", "EdgePoint" : "EdgePoint"});

export default SPLM;